// extracted by mini-css-extract-plugin
export default {"contentForm":"PlacesWaitlist_contentForm__M19vQ"};